module.exports = __webpack_public_path__ + "img/Media-Video.ecf054a1.svg";